'use strict';

angular.module('web2print.recipients')
  .filter('highlight', function ($sce) {
    return function (haystack, needle, minLength) {
      minLength = minLength || 0;

      if (angular.isDefined(needle) && angular.isDefined(haystack) && needle.length >= minLength) {
        haystack = haystack.replace(new RegExp('(' + needle + ')', 'gi'),
          '<span class="highlighted">$1</span>');
      }

      return $sce.trustAsHtml(haystack);
    };
  });
